export default "__VITE_ASSET__BplDlwaU__"